import React from "react";
import { Link } from "react-router-dom";

function BrandLogo({ className = "" }) {
  return (
    <Link
      to="/login"
      className={`text-2xl font-logo text-black no-underline ${className}`}
    >
      ByeByeRegrets
    </Link>
  );
}

export default BrandLogo;
